import { Action } from "./Action";
import { ActionCentre } from "./ActionCentre";
import { Actions, IAction } from "./types";

declare var _gaq: any;

export class FeedbackPopOver {

    private actionCentre: ActionCentre;

    constructor(actionsService: ActionCentre) {
        this.actionCentre = actionsService;
        this.runEventBinding();
    }

    private runEventBinding(): void {
        const trigger: HTMLElement = document.querySelector("[data-feedback-open]") as HTMLElement;
        const closeButton: HTMLElement = document.querySelector("[data-feedback-close]") as HTMLElement;
        const body: HTMLElement = document.querySelector("body") as HTMLElement;

        if (trigger) {
            trigger.addEventListener("click", (e) => {
                e.stopPropagation();
                const action = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
                this.actionCentre.Do(action);
                body.classList.add("body2018--feedback-open");
                _gaq.push(["_trackEvent", "Interaction", "View feedback", document.URL, 0, false]);
            });
        }
        
        if (closeButton) {
            closeButton.addEventListener("click", (e) => {
                e.stopPropagation();
                const action = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
                this.actionCentre.Do(action);
                body.classList.remove("body2018--feedback-open");
            });
        }
        
        if (body) {
            body.addEventListener("click", () => {
                closeButton.click();
            });
        }        
    }
}



// WEBPACK FOOTER //
// ./src/global/FeedbackPopOver.ts